module.exports = __webpack_public_path__ + "images/welcome_panel/welcome-panel-icons.png";